<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TimelineDetailResettleAuditDrawer',
})
</script>
<template>
  <Drawer v-model:visible="visible" title="详情" width="1000px" destroyOnClose>
    <Skeleton :loading="loading" active :paragraph="{ rows: 10 }"> <Detail :record="result" /> </Skeleton>
  </Drawer>
</template>

<script lang="ts" setup name="TimelineDetailResettleAuditDrawer">
import { Drawer, Skeleton } from 'ant-design-vue'
import { ref } from 'vue'
import { API_RESETTLE_AUDIT_DETAIL } from '@/api/resettleAudit'
import { useFetch } from '@/hooks/useFetch'
import Detail from './index.vue'

const visible = ref(false)
const { result, loading, fetchData } = useFetch({
  getFn: API_RESETTLE_AUDIT_DETAIL,
  isShallow: true
})
const open = (id: string) => {
  visible.value = true
  fetchData(id)
}
defineExpose({
  open,
  result
})
</script>
